import { HttpParams } from '@angular/common/http';
import { AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import * as moment from 'moment';
import { SelectItem } from 'primeng/api';
import { Subscription } from "rxjs";

import { InformationComponent } from '../../core/information/information.component';
import { ApiService } from '../../services/api.service';
import { AuthenticationService } from '../../services/authentication.service';
import { CALENDAR_LOCALE } from '../../services/constant';
import { TemplateService } from '../../services/template.service';
import { DownloadLogComponent } from '../download-log/download-log.component';

@Component({
  selector: 'app-tax-report',
  templateUrl: './tax-report.component.html',
  styleUrls: ['./tax-report.component.scss'],
  providers: [TemplateService]
})
export class TaxReportComponent implements OnInit, AfterViewChecked, OnDestroy {
  itemsPerPage = 40;

  calendarLocale;
  selectedCompany: SelectItem[];
  company: any;
  startDate: Date;
  endDate: Date;
  minDate: Date;
  maxDate: Date;
  allBranch = true;
  allDocType = true;
  notApprove: any;
  branch: any;
  selectedBranch: any;
  branchSuggest: any;
  documentType: any;
  tableData: any;
  modal: NgbModalRef;
  currentPage = 1;
  totalItems: number;
  loading = false;
  no_data = true;
  errorMsg = '';
  modalData: any;
  loadingExcel = false;
  confirm_loading = false;
  branchList: any = null;
  allBranchList: any = null;
  rdDocumentType: any;
  selectedRdDocumentType: any;
  sortBy: string;
  sortMode: string;
  tableCol = [];
  subs: Subscription;

  @ViewChild('content') content: any;
  @ViewChild('tt') table: any;

  constructor(
    private apiService: ApiService,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef,
    private authService: AuthenticationService,
    private template: TemplateService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.subs = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.loadTexts();
      this.searchData();
    });
    this.loadTexts();
    this.searchData();
  }

  get currentLang(): string {
    return this.translate.currentLang;
  }

  loadTexts() {
    this.tableCol = [];
    if (this.translate.currentLang === 'en') {
      this.calendarLocale = CALENDAR_LOCALE.EN;
    } else {
      this.calendarLocale = CALENDAR_LOCALE.TH;
    }
    this.translate.get('FILTER.DATE').subscribe((res: string) => {
      this.tableCol.push({field: 'date', header: res},
        {field: 'branch', header: this.translate.instant('TABLE.BRANCH-NAME')},
        {field: 'rd_doc_type', header: this.translate.instant('FILTER.DOCUMENT-TYPE')},
        {field: 'start_end_document', header: this.translate.instant('TABLE.DOCUMENT-NUMBER-START-END')},
        {field: 'total_doc', header: this.translate.instant('TABLE.NUMBER-DOCUMENTS')},
        {field: 'total_missing_doc', header: this.translate.instant('TABLE.NUMBER-MISSING-DOCUMENTS')},
        {field: 'non_vat', header: this.translate.instant('TABLE.SALES') + ' Non-VAT'},
        {field: 'basis_amount', header: this.translate.instant('TABLE.SALES') + ' VAT'},
        {field: 'vat', header: 'VAT'});
      const documentData = this.template.getDropdown();
      documentData[0] = {label: this.translate.instant('COMMON.ALL'), value: null};
      this.rdDocumentType = documentData;
      this.tableCol = _.uniqBy(this.tableCol, 'field');
      this.loadInput();
    });
  }

  get yearRange() {
    const thisYear = (new Date()).getFullYear();
    return (thisYear - 40) + ':' + thisYear;
  }

  get dateRange() {
    const start = moment(this.startDate).format('DD/MM/YYYY');
    const end = moment(this.endDate).format('DD/MM/YYYY');
    return start + ' - ' + end;
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  loadInput() {
    this.company = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    this.apiService.getCompany().subscribe(
      (result) => {
        _.forEach(result, (obj) => {
          this.company.push({
            label: obj.name,
            value: obj.id
          });
        });
        this.company = _.uniqBy(this.company, 'label');
      },
      error => {
        console.log('error', error);
      }
    );

    this.apiService.getBranch().subscribe(
      (result) => {
        this.allBranchList = result;
        this.filterBranchList();
      }
    );

    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 60);
    this.endDate = new Date();
    this.selectedCompany = null;
    this.selectedRdDocumentType = null;
  }

  filterBranchList() {
    this.selectedBranch = null;

    this.branchList = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    _.forEach(this.allBranchList, (obj) => {
      if (this.selectedCompany == null || obj.corporate == this.selectedCompany) {
        this.branchList.push({
          label: obj.full_name,
          value: obj.id
        });
      }
    });
  }

  pageChanged() {
    const params = new HttpParams().set('page', _.toString(this.currentPage));
    this.searchData(params);
  }

  searchButtonClicked() {
    this.currentPage = 1;
    this.sortBy = null;
    this.sortMode = null;
    if (!this.no_data) {
      this.table.reset();
    }
    this.searchData();
  }

  setMinDate() {
    this.minDate = this.startDate;
    if (this.endDate < this.minDate) {
      this.endDate = this.minDate;
    }
  }

  setMaxDate() {
    this.maxDate = this.endDate;
    if (this.startDate > this.maxDate) {
      this.startDate = this.maxDate;
    }
  }

  canUserApproveDoc() {
    return this.authService.isAccountant();
  }

  selectAllBranch() {
    this.branch = null;
  }

  selectDocType() {
    this.documentType = null;
  }

  searchData(params?) {
    this.loading = true;
    this.checkCondition();

    if (this.errorMsg.length > 0) {
      this.loading = false;
      return;
    }

    const data = {
      not_approved_only: this.notApprove,
      header_issue_date_start: moment(this.startDate).format('YYYY-MM-DD'),
      header_issue_date_end: moment(this.endDate).format('YYYY-MM-DD'),
      corporate_id: this.selectedCompany,
      branch_id: this.selectedBranch ? this.selectedBranch : null,
      items_per_page: this.itemsPerPage,
      rd_doc_type: this.selectedRdDocumentType
    };

    if (this.sortBy && this.sortMode) {
      data['sort'] = this.sortBy;
      data['sort_type'] = this.sortMode;
    }

    if (this.currentPage === 1) {
      params = null;
    }

    this.apiService.postSaleTax(data, params).subscribe(
      (result) => {
        this.loading = false;
        this.tableData = result.results;
        this.no_data = _.isEmpty(this.tableData);
        this.totalItems = result.count;
      },
      error => {
        this.loading = false;
        this.no_data = true;
        this.errorMsg = this.translate.instant('ERROR.TRY-AGAIN');
      }
    );
  }

  confirmDocument(event, content, index) {
    document.getElementById('chkbox' + index).blur();
    event.preventDefault();

    this.modalData = this.tableData[index];
    this.modal = this.modalService.open(content, {backdrop: 'static', keyboard: false, centered: true});
  }

  confirm() {
    this.confirm_loading = true;

    const params = {
      approved: this.modalData.approved,
      header_issue_date: this.modalData.header_issue_date,
      group: this.modalData.group,
      document_type: this.modalData.document_type,
      rd_document_type: this.modalData.rd_document_type,
      corporate_branch: this.modalData.corporate_branch,
      header_invoice_numbers: this.modalData.header_invoice_numbers
    };

    this.apiService.approveSale(params).subscribe(
      (result) => {
        this.confirm_loading = false;
        this.modal.close();
        this.modal = null;
      },
      error => {
        this.confirm_loading = false;
      }
    );
  }

  revertBack() {
    this.modalData.approved = !this.modalData.approved;
    this.modal.close();
    this.modal = null;
  }

  clearData() {
    this.tableData = undefined;
    this.no_data = true;
    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 60);
    this.endDate = new Date();
    this.selectedCompany = null;
    this.selectedBranch = null;
    this.selectedRdDocumentType = null;
    this.branch = null;
    this.documentType = null;
    this.notApprove = false;
    this.allDocType = true;
    this.allBranch = true;
    this.sortBy = null;
    this.sortMode = null;

    this.searchButtonClicked();
  }

  getExportDocs(data, index) {
    this.tableData[index].loading_all_docs_excel = true;

    const params = {
      header_issue_dt: data.header_issue_date,
      document_type: data.document_type,
      rd_document_type: data.rd_document_type,
      corporate_branch: data.corporate_branch,
      group: data.group,
    };
    this.apiService.exportSalesTaxReport(params).subscribe(
      () => {
        this.tableData[index].loading_all_docs_excel = false;
        this.informUser(
          this.translate.instant('COMMON.ADDED-TO-QUEUE')
        );
      },
      (error) => {
        this.tableData[index].loading_all_docs_excel = false;
        this.informUser();
      }
    );
  }

  informUser(message?: string) {
    const modal = this.modalService.open(InformationComponent, { centered: true });
    modal.componentInstance.message = message || this.translate.instant('ERROR.TRY-AGAIN');
  }

  showDownloadLogs() {
    const modal = this.modalService.open(DownloadLogComponent, { size: 'lg' });
    modal.componentInstance.feature = 'sales_tax_report';
  }

  downloadMissingDocs(data, index) {
    this.tableData[index].loading_missing_docs_excel = true;
    const params = {
      header_issue_dt: data.header_issue_date,
      document_type: data.document_type,
      rd_document_type: data.rd_document_type,
      corporate_branch: data.corporate_branch,
      max_document: data.max_document,
      min_document: data.min_document,
      group: data.group,
    };
    this.apiService.getMissingDoc(params).subscribe(
      (obj) => {
        this.tableData[index].loading_missing_docs_excel = false;
        const filename = 'daily_missing ' + params.header_issue_dt + '.xlsx';
        this.apiService.createDownloadFile(obj, filename);
      },
      error => {
        this.tableData[index].loading_missing_docs_excel = false;
      }
    );
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  checkCondition() {
    this.errorMsg = '';

    const errorMsgList = [];
    if (_.isEmpty(this.branch) && this.allBranch === false) {
      errorMsgList.push(this.translate.instant('FILTER.BRANCH'));
    }

    if (_.isEmpty(this.documentType) && this.allDocType === false) {
      errorMsgList.push('Doc Type');
    }

    if (errorMsgList.length > 0) {
      this.errorMsg = this.translate.instant('COMMON.SPECIFY') + errorMsgList.join(', ') + this.translate.instant('COMMON.CORRECT');
      return;
    }
  }

  sort(event) {
    this.sortBy = event.field;
    if (event.order === 1) {
      this.sortMode = 'asc';
    } else {
      this.sortMode = 'desc';
    }
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: 'SALES_TAX_REPORT',
      target: target
    };
    this.apiService.sniff(data).subscribe(
      (res: any) => {
      },
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/tax-report/tax-report.component.ts